import React from 'react';

/* eslint-disable max-len */
export default {
  line1a: {
    label: <span>First name <sup>*</sup></span>,
    hint: 'Enter at least your first name and last name.'
  },
  line1b: {
    label: 'Business Name of Sole Proprietor',
    hint: 'Enter the Business Name of the Sole Proprietor if applicable.'
  },
  line1c: {
    label: <span>Residence address: Address line <sup>1</sup>*</span>,
    hint: 'Your permanent residence address is the address in the country where you claim to be a resident for purposes of that country’s income tax. Do not show the address of a financial institution, a post office box, or an address used solely for mailing purposes. If you do not have a tax residence in any country, your permanent residence is where you normally reside. If you reside in a country that does not use street addresses, you may enter a descriptive address on Address line. The address must accurately indicate your permanent residence in the manner used in your jurisdiction.'
  },
  line1d: {
    label: 'Mailing address: Address line',
    hint: 'Enter your mailing address only if it is different from the address you populated in the Residence address.'
  },
  line1e: {
    label: <span>1e Date of Birth <sup>*</sup></span>,
    hint: 'Provide your date of birth. Use the following format to input your information: DD-MM-YYYY. For example, if you were born on April 15, 1956, you would enter 15-04-1956.'
  },
  line2a: {
    hint: <span>
      For federal tax purposes, you are considered a U.S. person if you are:
      <ul>
        <li>An individual who is a U.S. citizen or U.S. resident alien;</li>
        <li>A partnership, corporation, company, or association created or organized in the United States or under the laws of the United States;</li>
        <li>An estate (other than a foreign estate); or</li>
        <li>A domestic trust (as defined in Regulations section 301.7701-7).</li>
      </ul>
    </span>
  },
  'line2a US TIN': {
    hint: <span>
      If you have a social security number (SSN), enter it here. To apply for an SSN, get Form SS-5 from a Social Security Administration (SSA) office or online at www.ssa.gov/forms/ss-5.pdf.
      If you are in the United States, you can call the SSA at 1-800-772-1213. If you do not have an SSN and are not eligible to get one, you can get an individual taxpayer identification number (ITIN). To apply for an ITIN, file Form W-7 with the IRS. It usually takes 4–6 weeks to get an ITIN.
      A partner in a partnership conducting a trade or business in the United States will likely be allocated effectively connected taxable income. The partner is required to file a U.S. federal income tax return and must have a U.S. taxpayer identification number (TIN).
    </span>,
    caution: 'An ITIN is for tax use only. It does not entitle you to social security benefits or change your employment or immigration status under U.S. law.'
  },
  'line3.1a': {
    label: 'Country of Tax Residence *',
    hint: 'Enter the Country where you are a Tax Resident. If you have populated 2a and identify as a U.S. person - make sure you populate one of the sections in Part 3 with the details of your U.S. tax residency. '
  },
  'line3.1b': {
    label: <span>Residence address:Address line <sup style={ { top: '-0.5em' } }>1</sup>*</span>,
    hint: 'Make sure you provide the Residence address for the Country of Tax Residence you populated above. '
  },
  'line3.1c': {
    label: 'Tax Identification Number',
    hint: 'Provide your Tax Identification Number or Reason no TIN provided, taking into account the explanation about reasons A, B, and C above. '
  },
  'line3.2a': {
    label: 'Country of Tax Residence',
    hint: 'Enter the Country where you are a Tax Resident. If you have populated 2a and identify as a U.S. person - make sure you populate one of the sections in Part 3 with the details of your U.S. tax residency. '
  },
  'line3.2b': {
    label: <span>Residence address:Address line<sup style={ { top: '-0.5em' } }>1</sup></span>,
    hint: 'Make sure you provide the Residence address for the Country of Tax Residence you populated above. '
  },
  'line3.2c': {
    label: 'Tax Identification Number',
    hint: 'Provide your Tax Identification Number or Reason no TIN provided, taking into account the explanation about reasons A, B, and C above. '
  },
  'line3.3a': {
    label: 'Country of Tax Residence',
    hint: 'Enter the Country where you are a Tax Resident. If you have populated 2a and identify as a U.S. person - make sure you populate one of the sections in Part 3 with the details of your U.S. tax residency. '
  },
  'line3.3b': {
    label: <span>Residence address:Address line<sup style={ { top: '-0.5em' } }>1</sup></span>,
    hint: 'Make sure you provide the Residence address for the Country of Tax Residence you populated above. '
  },
  'line3.3c': {
    label: 'Tax Identification Number',
    hint: 'Provide your Tax Identification Number or Reason no TIN provided, taking into account the explanation about reasons A, B, and C above. '
  },
  'line3.4a': {
    label: 'Country of Tax Residence',
    hint: 'Enter the Country where you are a Tax Resident. If you have populated 2a and identify as a U.S. person - make sure you populate one of the sections in Part 3 with the details of your U.S. tax residency. '
  },
  'line3.4b': {
    label: <span>Residence address:Address line<sup style={ { top: '-0.5em' } }>1</sup></span>,
    hint: 'Make sure you provide the Residence address for the Country of Tax Residence you populated above. '
  },
  'line3.4c': {
    label: 'Tax Identification Number',
    hint: 'Provide your Tax Identification Number or Reason no TIN provided, taking into account the explanation about reasons A, B, and C above. '
  },
  'line3.5a': {
    label: 'Country of Tax Residence',
    hint: 'Enter the Country where you are a Tax Resident. If you have populated 2a and identify as a U.S. person - make sure you populate one of the sections in Part 3 with the details of your U.S. tax residency. '
  },
  'line3.5b': {
    label: <span>Residence address:Address line<sup style={ { top: '-1em' } }>1</sup></span>,
    hint: 'Make sure you provide the Residence address for the Country of Tax Residence you populated above. '
  },
  'line3.5c': {
    label: 'Tax Identification Number',
    hint: 'Provide your Tax Identification Number or Reason no TIN provided, taking into account the explanation about reasons A, B, and C above. '
  },
  'lineSigned Date': {
    label: <span>Date <sup>*</sup>:</span>,
    hint: 'Use the following format to input information about your signature date: DD-MM-YYYY. For example, if the signature date is April 15, 2022, you would enter 15-04-2022.'
  }
};
